import 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

import 'element-ui/lib/theme-chalk/index.css'
import app from './App.vue'
import routes from './router.js'
import VueRouter from 'vue-router'
import store from './store/index.js'
import echarts from 'echarts'

// import VueI18n from 'vue-i18n'

// Vue.use(VueI18n)
// const i18n = new VueI18n({
//     locale: 'zh-CN',    // 语言标识
//     //this.$i18n.locale // 通过切换locale的值来实现语言切换
//     messages: {
//       'zh-CN': require('./components/lang/zh.js'),   // 中文语言包
//       'en-US': require('./components/lang/en.js')    // 英文语言包
//     }
// })

let storage = window.localStorage;
let version = 0;
if(storage.getItem("UserInformation")){
	var UserInformation = JSON.parse(storage.getItem("UserInformation"));
	if(UserInformation.data){
		if(UserInformation.data.version){
			version = UserInformation.data.version;
		}
	}
}
if(version == 0){
	Vue.use(ElementUI)
}else{
	 Vue.use(ElementUI, { locale })
}

Vue.prototype.$echarts = echarts
Vue.use(VueRouter)
const router = new VueRouter({
	routes
});

import baseApi from './api/base.js'
import allUrl from './api/allUel.js'

var url = window.location.href.split("/")[2];
	// console.log(url,'---------')
var protocolStr = document.location.protocol;
if(protocolStr == "http:"){

}else if(protocolStr == "https:"){
    let subStr=new RegExp('http:');//创建正则表达式对象
    for(let i in allUrl){
        for(let key in allUrl[i]){
          allUrl[i][key]=allUrl[i][key].replace(subStr,protocolStr);
      	}
    }
}
var street;
if(url == 'localhost:8080' || url == '127.0.0.1:8080'){
	// street = 'newtest.solar-iot.com'
	street = 'new.solar-iot.com';
	// street = '10.0.0.123';
	protocolStr = 'https:'
}else if(url == 'solar.iotena.com'||url == 'www.illuminatingyourworld.com'||url == 'sels.solar-iot.com'){
	// street = 'new.solar-iot.com'
    street = url;
}else{
    street = url;
}
let subStr=new RegExp('newtest.solar-iot.com');//创建正则表达式对象
for(let i in allUrl){
    for(let key in allUrl[i]){
      allUrl[i][key]=allUrl[i][key].replace(subStr,street);
  	}
}

let isTrue = true;
router.beforeEach((to, from, next) => {
	if(isTrue){
		isTrue = false;
    	store.commit('routerLink',{
			linkTo:to.path
	    })
		next();
	}else{
		if(to.path == '/home' || to.path == '/' || to.path == '/userManagement' || to.path == '/projectSummary'){
	    	store.commit('routerLink',{
				linkTo:to.path
		    })
			next();
		}
		let arr= [{key:'2',val:'/GISMap'},{key:'3',val:'/projectManagement'},
				{key:'7',val:'/alarmMaintenance'},{key:'7',val:'/repairPersonnel'},{key:'7',val:'/maintenanceRecord'},{key:'7',val:'/streetLightInformation'},
				{key:'12',val:'/historicalData'},
				{key:'53',val:'/videoSurveillance'},{key:'53',val:'/monitoringDetails'},
				{key:'55',val:'/weatherMonitor'},
				{key:'15',val:'/operationLog'},
				{key:'60',val:'/grouping'},{key:'60',val:'/addGrouping'},
				{key:'6',val:'/strategy'},
				{key:'55',val:'/weatherMonitor'},{key:'55',val:'/monitorDetails'},{key:'55',val:'/monitoringContrast'},]
		console.log(to.path,store.getters.privilege)

		let data;
		if(storage.getItem("UserInformation") != 'false' && storage.getItem("UserInformation")){
			console.log(JSON.parse(storage.getItem("UserInformation")))
			data = JSON.parse(storage.getItem("UserInformation")).data;
			let isImplement = false;
			for(let d of arr){
				if(d.val==to.path){
					for(let val of data.privilege){
						if(d.key == val){
							isImplement = true;
						}
					}
				}
			}
			// console.log(arr,to.path,'-----------------',data.privilege)
			if(data.role == '1' || to.path == '/' || to.path == '/home' || to.path == '/userManagement' || to.path == '/projectSummary'){
				isImplement = true;
			}
			if(isImplement){
				if(to.path == '/'){
					var time = setInterval(function(){
						if(document.getElementsByClassName('header')[0]){
							document.getElementsByClassName('header')[0].className = 'header_centre box';
							clearInterval(time)
						}else if(document.getElementsByClassName('header_centre')[0]){
							clearInterval(time)
						}
					},10)
				}else{
					var time = setInterval(function(){
						if(document.getElementsByClassName('header_centre')[0]){
							document.getElementsByClassName('header_centre')[0].className = 'header box';
							clearInterval(time)
						}else if(document.getElementsByClassName('header')[0]){
							clearInterval(time)
						}
					},10)
				}
				store.commit('routerLink',{
					linkTo:to.path
			    })
		  		next();
			}else{
				store._vm.$message({
			      showClose: true,
			      message:store._vm.version==0?'无查看权限':'No view permissions',
			      type: 'warning'
			    });
			}
		}else{
			storage.setItem('loginState','false');
		    window.location.href='login.html';
		}
	}
})

var vm=new Vue({
  store,
  router,
  el: '#app',
  // i18n,
  components:{
  	app
  }
})
// router.push('./home');


// WEBPACK FOOTER //
// ./src/main.js